<template>
  <div :class="'myFooter_warp '">
    <el-row class="top" :gutter="20">
      <el-col :span="8" class="main-content">
        <div class="title">{{ $t('copyright') }}</div>
        <div class="content">
          <router-link to="/" :aria-label="$t('home')"><img class="icon" :src="logo" alt="" /></router-link>
        </div>
      </el-col>
      <el-col :span="8" class="main-content">
        <div class="title">{{ $t('contactUs') }}</div>
        <div class="content">
          <p>{{ $t('Address') }}{{ $t('detailAddress') }}</p>
          <p>{{ $t('Tel') }}025-58641549</p>
          <p>{{ $t('Email') }}nrcmm@nju.edu.cn</p>
          <p>{{ $t('PageViews') }}{{ num }}</p>
        </div>
      </el-col>
      <el-col :span="8" class="main-content">
        <div class="title">{{ $t('quickNav') }}</div>
        <div class="content">
          <router-link class="nav-link" to="/resourceHome">{{ $t('resourceSearch') }}</router-link>
          <router-link class="nav-link" to="/techService">{{ $t('techService') }}</router-link>
          <router-link class="nav-link" to="/news">{{ $t('news') }}</router-link>
          <router-link class="nav-link" to="/about">{{ $t('about') }}</router-link>
        </div>
      </el-col>
    </el-row>

    <div class="bottom">
      <p>{{ $t('detailCopyright') }}</p>
      <p>网站建设：
        <a href="https://www.vsynclab.com/" target="_blank" rel="noopener noreferrer">南京生三生物</a>
      </p>
    </div>
  </div>
</template>

<script>
import logo from "../../assets/icon/footerLogo.png";
import mixins from "@/mixins/mixins";
import { GetVisitCountApi } from "@/utils/api";

export default {
  name: "myFooter",
  mixins: [mixins],
  props: {
    address: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      logo, // logo 图标
      num: 0, // 访问量
    };
  },
  created() {
    this.getVisitNum();
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  methods: {
    toDetail() {
      window.open('https://www.vsynclab.com/', 'blank')
    },
    handleNav(path) {
      if (this.$route.path !== path) {
        this.$router.push(path).catch(err => { });
      }
      window.scrollTo(0, 0);
    },
    // 获取访问量
    getVisitNum() {
      GetVisitCountApi()
        .then((res) => {
          this.num = res || 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.myFooter_warp {
  background-color: #0c0f17;
  font-size: 14px;

  .top {
    height: 228px;
    padding: 57px 61px 35px 61px;

    .main-content {
      text-align: left;

      .icon {
        height: 42px;
      }

      .title {
        margin-bottom: 30px;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 10px;
      }

      .content {
        >p, >a {
          display: block;
          text-decoration: none;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.6);
          margin-bottom: 10px;

          &.nav-link {
            cursor: pointer;
            transition: color 0.3s;

            &:hover {
              color: #ffffff;
            }
          }
        }
      }
    }
  }

  .bottom {
    height: 65px;
    width: 100%;
    text-align: center;
    border-top: 2px solid rgba(255, 255, 255, 0.1);
    padding-top: 26px;
    padding-bottom: 29px;
    background-color: #0c0f17;

    p {
      display: inline;
      text-align: center;
      font-size: 12px;
      margin-right: 1rem;
      color: rgba(255, 255, 255, 0.5);
    }
  }
}

@media (max-width: 768px) {
  .myFooter_warp {
    .top {
      height: auto;
      padding: 30px 20px;
      display: flex;
      flex-direction: column;

      ::v-deep .el-col {
        width: 100% !important;
        margin-bottom: 30px;
      }
    }

    .bottom {
      height: auto;
      padding: 20px;
    }
  }
}
</style>
